import { Link } from "react-router-dom";
import { Phone, MessageCircle } from "lucide-react";

export function Footer({ settings }) {
  const phone = settings?.phone || "07 60 00 10 96";
  const wa = settings?.whatsapp || "33760001096";
  return (
    <footer className="bg-brand-green text-white mt-24">
      <div className="brand-container py-14 grid grid-cols-1 sm:grid-cols-3 gap-10">
        <div>
          <h3 className="font-serif text-2xl mb-3">{settings?.shop_name || "Zeitrog"}</h3>
          <p className="text-white/70 text-sm leading-relaxed">
            Sets loulav/etrog pour Souccot. Livraison sur Paris & toute l'Île-de-France ou retrait dans le 19e arrondissement.
          </p>
        </div>
        <div>
          <h4 className="text-sm uppercase tracking-widest text-brand-gold mb-3">Liens</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/comparatif" className="hover:text-brand-gold">Comparatif des gammes</Link></li>
            <li><Link to="/commander" className="hover:text-brand-gold">Commander</Link></li>
            <li><Link to="/cgv" className="hover:text-brand-gold">CGV</Link></li>
            <li><Link to="/mentions-legales" className="hover:text-brand-gold">Mentions légales</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm uppercase tracking-widest text-brand-gold mb-3">Contact</h4>
          <a href={`tel:${phone.replace(/\s/g, "")}`} data-testid="footer-phone" className="flex items-center gap-2 text-white/90 hover:text-brand-gold mb-3">
            <Phone className="w-4 h-4" /> {phone}
          </a>
          <a href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="inline-flex items-center gap-2 rounded-full bg-brand-gold text-brand-green px-4 py-2 text-sm font-semibold hover:bg-brand-goldHover">
            <MessageCircle className="w-4 h-4" /> WhatsApp
          </a>
        </div>
      </div>
      <div className="border-t border-white/10 py-4 text-center text-xs text-white/50">
        © 2026 {settings?.legal_name || "Zeitrog"} — {settings?.legal_form || "Auto-entrepreneur"}
      </div>
    </footer>
  );
}
